import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect
} from 'react';
import {DateRange} from 'react-date-range';
import {Popover, Button} from 'react-bootstrap';
import {format} from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const DatePicker = forwardRef(({onSelect}, ref) => {
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (pickerRef.current && !pickerRef.current.contains(event.target)) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    if (showPicker) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showPicker]);

  const getData = (data) => {
    const {selection} = data;
    const startTimestamp = selection.startDate
      ? selection.startDate.getTime()
      : null;
    const endTimestamp = selection.endDate ? selection.endDate.getTime() : null;

    setState([
      {
        startDate: selection.startDate,
        endDate: selection.endDate,
        key: 'selection'
      }
    ]);
    setStartDate(startTimestamp);
    setEndDate(endTimestamp);

    onSelect({startDate: startTimestamp, endDate: endTimestamp});
  };

  let dateText = 'Select Date';
  if (startDate || endDate) {
    dateText = `${format(new Date(startDate), 'MM/dd/yyyy')} - ${format(
      new Date(endDate),
      'MM/dd/yyyy'
    )}`;
  }

  useImperativeHandle(ref, () => ({
    resetDatePicker() {
      setState([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: 'selection'
        }
      ]);
      setStartDate(null);
      setEndDate(null);
    }
  }));

  return (
    <div ref={pickerRef} style={{position: 'relative', display: 'block'}}>
      <Button
        variant="primary col-md-12"
        onClick={() => setShowPicker(!showPicker)}
      >
        {dateText}
      </Button>
      {showPicker && (
        <Popover
          className="wise-date-picker"
          style={{position: 'absolute', zIndex: 1000, top: '40px', left: 0}}
        >
          <Popover.Header as="h4">Select Date Range</Popover.Header>
          <Popover.Body>
            <DateRange
              editableDateInputs={false}
              onChange={getData}
              moveRangeOnFirstSelection={false}
              ranges={state}
            />
          </Popover.Body>
        </Popover>
      )}
    </div>
  );
});

export default DatePicker;
